import {Tag} from 'yougile-model'
import {excludeTaskTemplateStickers} from '@extensions/task'

export const filterCustomStickers = (
  stickers: Tag[],
  needUser?: boolean
): Tag[] => {
  if (needUser) {
    const excl = excludeTaskTemplateStickers.filter(e => e !== 'User')
    return stickers.filter(s => !excl.includes(s.title))
  }
  return stickers.filter(s => !excludeTaskTemplateStickers.includes(s.title))
}
